module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-wrap"
  }, [_c('div', {
    ref: "mask",
    staticClass: "mask-transition"
  }, [_c('div', {
    staticClass: "mask-bg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "images-wrap"
  }, _vm._l((_vm.imagesArray), function(image, index) {
    return _c('img', {
      key: index,
      class: _vm.indexActive === index ? 'show' : '',
      attrs: {
        "src": require('../../assets/images/' + image)
      }
    })
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117f0c3a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CarouselProds.vue
// module id = 362
// module chunks = 0